module.exports = __webpack_public_path__ + "static/media/bitJob.82805a6d.png";